import {ValueObject} from '@s-ui/domain'

export class CarouselInfoValueObject extends ValueObject {
  /**
   * @param {String} title
   * @param {Array<LatestModelValueObject>} items
   * */
}
